/* ========================== */
/*         HOME HERO          */
/* ========================== */
homeFeatCardsSlider = {
    init: function () {
        if ($(".swiper--home-feat-cards").length > 0) {
            var swiper = new Swiper(".swiper--home-feat-cards", {
                slidesPerView: "auto",
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                navigation: {
                    nextEl: ".swiper--home-feat-cards .swiper-btn.btn--next",
                    prevEl: ".swiper--home-feat-cards .swiper-btn.btn--prev",
                  },
            });
        }
    }
};

$(document).ready(function () {
    homeFeatCardsSlider.init();
});


